<template>
  <div
    class="fixed inset-0 z-30 p-4 overflow-x-hidden md:inset-0 flex items-center justify-center"
  >
    <div
      @click="$emit('close')"
      class="absolute inset-0 z-10 bg-black opacity-30 -m-4"
    ></div>
    <div class="relative w-full max-w-4xl max-h-full z-20">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
        <!-- Modal body -->
        <slot></slot>
        <!-- Modal footer -->
        <div
          v-if="footer"
          class="flex items-center p-4 space-x-2 border-gray-200 rounded-b justify-end"
        >
          <button @click="$emit('close')" :class="declineClass">
            {{ declineTitle }}
          </button>
          <button @click="$emit('confirm')" :class="confirmClass">
            {{ confirmTitle }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confirmTitle: {
      type: String,
      default: "Simpan",
    },
    declineTitle: {
      type: String,
      default: "Batal",
    },
    confirmClass: {
      type: String,
      default: "text-white btn bg-rose-600 hover:bg-rose-700 btn-sm",
    },
    declineClass: {
      type: String,
      default: "btn btn-outline btn-sm",
    },
    footer: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style></style>
